import '@adminStyles/editors/classicEditor/_classicEditor.scss';
import '@adminStyles/index.scss';
import { initCopyShortcodeHandler } from '@sharedUtils/copyShortcodeHandler.js';
// import { initSmartContentSyncClassicEditorTinyMCE } from './libs/editors/classicEditor/tinymceSmartContentButton';
import { initSmartContentSyncClassicEditorMetabox } from './libs/editors/classicEditor/metaboxSmartContentInsert';
import { initAutoInsertGroupControls } from './autoInsertGroupControls';

document.addEventListener('DOMContentLoaded', () => {
  initCopyShortcodeHandler();

  //#region classic editor integrations

  // initSmartContentSyncClassicEditorTinyMCE();
  initSmartContentSyncClassicEditorMetabox();

  //#endregion classic editor integrations

  // auto-insert meta box. Example: "Select All", and "Deselect All" buttons
  initAutoInsertGroupControls();
});
